export default async function (error) {
  if (process.server) {
    const { loggers } = await import('@bukalapak/middleware-logging')
    const { Sentry } = await import('~/server/services/sentry')
    loggers.jsonLogger.error(error)
    Sentry.captureException(error)
  }
}
